<div
  class="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-100 to-purple-100 p-4"
>
  <div
    class="w-full max-w-md overflow-hidden bg-white rounded-xl shadow-lg transform transition-all duration-500 hover:shadow-2xl hover:scale-[1.02]"
  >
    <!-- Logo and header section -->
    <div class="bg-gradient-to-r from-blue-600 to-indigo-700 p-6 text-white text-center">
      <h2
        class="text-3xl font-bold mb-2 transform transition-all duration-700 opacity-0 translate-y-4 animate-fadeIn"
      >
        Rectilineus
      </h2>
      <p
        class="text-blue-100 transform transition-all duration-700 delay-300 opacity-0 translate-y-2 animate-fadeIn"
      >
        Admin Dashboard
      </p>
    </div>

    <div class="p-8">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
        <div
          class="transform transition-all duration-700 delay-500 opacity-0 translate-y-4 animate-fadeIn"
        >
          <label for="email" class="block mb-2 text-sm font-medium text-gray-700"
            >Email Address</label
          >
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                />
              </svg>
            </div>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="you@example.com"
              class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
              [ngClass]="{ 'border-red-500 bg-red-50': submitted && f['email'].errors }"
            />
          </div>
          <div
            *ngIf="submitted && f['email'].errors"
            class="mt-1 text-sm text-red-600 animate-pulse"
          >
            <div *ngIf="f['email'].errors['required']">Email is required</div>
            <div *ngIf="f['email'].errors['email']">Please enter a valid email address</div>
          </div>
        </div>

        <!-- Password field with icon -->
        <div
          class="transform transition-all duration-700 delay-700 opacity-0 translate-y-4 animate-fadeIn"
        >
          <label for="password" class="block mb-2 text-sm font-medium text-gray-700"
            >Password</label
          >
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>
            <input
              type="password"
              id="password"
              formControlName="password"
              placeholder="••••••••"
              class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
              [ngClass]="{ 'border-red-500 bg-red-50': submitted && f['password'].errors }"
            />
          </div>
          <div
            *ngIf="submitted && f['password'].errors"
            class="mt-1 text-sm text-red-600 animate-pulse"
          >
            <div *ngIf="f['password'].errors['required']">Password is required</div>
          </div>
        </div>

        <!-- Error message -->
        <div
          *ngIf="error"
          class="p-3 bg-red-100 text-red-700 rounded-lg border border-red-200 transform transition-all duration-300 animate-shake"
        >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
            {{ error }}
          </div>
        </div>

        <!-- Login button -->
        <div
          class="transform transition-all duration-700 delay-1000 opacity-0 translate-y-4 animate-fadeIn"
        >
          <button
            type="submit"
            class="group w-full flex justify-center items-center px-4 py-2 text-white bg-gradient-to-r from-indigo-600 to-blue-700 rounded-lg hover:from-indigo-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
          >
            <span>Sign In</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 ml-2 transform transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<style>
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes shake {
    0%,
    100% {
      transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70%,
    90% {
      transform: translateX(-5px);
    }
    20%,
    40%,
    60%,
    80% {
      transform: translateX(5px);
    }
  }

  .animate-fadeIn {
    animation: fadeIn 0.8s forwards;
  }

  .animate-shake {
    animation: shake 0.5s forwards;
  }
</style>
